import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import classNames from "classnames";
import { Field, useFormikContext } from "formik";
import { useState } from "react";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const FileInput: React.FC<Props> = (props) => {
  const { commonAttrs, classes } = props;
  const { name, id } = commonAttrs;
  const [fileValue, setFileValue] = useState<string>("");
  const { setFieldValue } = useFormikContext<{ [key: string]: string }>();
  const { validate } = useFormContext();
  const { fieldRef } = useFocusInvalidField(name, true);
  return (
    <Field
      type={"file"}
      name={name}
      className={classNames(classes.join(" "))}
      validate={(v: any) => validate(name, v)}
      id={id}
      value={fileValue}
      onChange={(e: any) => {
        setFileValue(e.target.value);
        setFieldValue(
          name,
          !!e.target.files?.length ? e.target.files[0] : null
        );
      }}
      innerRef={(el: HTMLElement) => {
        fieldRef.current = el;
      }}
    />
  );
};

export default FileInput;
